import { render, staticRenderFns } from "./AnnouncementModal.vue?vue&type=template&id=6758fdbb"
import script from "./AnnouncementModal.vue?vue&type=script&lang=ts"
export * from "./AnnouncementModal.vue?vue&type=script&lang=ts"
import style0 from "./AnnouncementModal.vue?vue&type=style&index=0&id=6758fdbb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports